<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-content">
      <div class="info-content--top">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
        </div>
        <div class="group-info-item title-margin">
          <h2 langkey="phRemoteOrder_DefineTime_Title"></h2>
        </div>
      </div>
      <div class="form__list">
        <div class="form-input_info">
          <p class="text">{{serviceTimeInfo}}</p>
        </div>
        <!-- Select service time (pickup / delivery)-->
        <div class="time-content" id="serviceDateContent">
          <ng-container *ngIf="dayList$|async;let dayList">
            <div class="selection">
              <span class="select-info">{{serviceDayLabel}}</span>
              <div class="dropdown-container">
                <div class="input-container-flex">
                  <select class="ya-input-text" (change)="selectionChangeServiceDay($event, dayList)">
                    <ng-container *ngFor="let day of dayList">
                      <option [(value)]="day.value" [selected]="isServiceDayselected(day.value)">
                        {{ day.key }}
                      </option>
                    </ng-container>
                  </select>
                  <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
                </div>
              </div>
            </div>
            <div class="selection">
              <span class="select-info">{{serviceTimeLabel}}</span>
              <div class="dropdown-container">
                <div class="input-container-flex">
                  <ng-container *ngIf="serviceOpenTime$|async; let openTimes">
                    <select class="ya-input-text" (change)="onServiceTimeChange($event.currentTarget.value,openTimes)">
                      <option value="" disabled selected></option>
                      <ng-container *ngFor="let serviceTime of openTimes; let index = index">
                        <option [value]="index"
                          [selected]="isTimeSelected(serviceTime,selectedServiceTime,index,selectedServiceTimeIndex)">
                          {{serviceTime.display}}</option>
                      </ng-container>
                    </select>
                  </ng-container>
                  <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- Order time -->
        <div class="form-input_info">
          <h2 langkey="phRemoteOrder_DefineTime_Order_Title"></h2>
          <p class="text" langkey="phRemoteOrder_DefineTime_Order_Info"></p>
          <p class="text">{{orderTimeNotice}}</p>
        </div>
        <div class="time-content" id="orderDateContent">
          <ng-container *ngIf="dayList$|async;let dayList">
            <!--Select order day-->
            <div class="selection">
              <span class="select-info" langkey="phRemoteOrder_DefineTime_Order_Day"></span>
              <div class="dropdown-container">
                <div class="input-container-flex">
                  <select class="ya-input-text" (change)="selectionChangeOrderDay($event, dayList)">
                    <ng-container *ngIf="dayList.length>1">
                      <option value="" disabled selected></option>
                    </ng-container>
                    <ng-container *ngFor="let day of dayList">
                      <option [value]="day.value" [selected]="isOrderDaySelected(day.value)">
                        {{ day.key }}
                      </option>
                    </ng-container>
                  </select>
                  <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- select order time-->
          <ng-container>
            <div class="selection">
              <span class="select-info" langkey="phRemoteOrder_DefineTime_Order_Time"></span>
              <div class="dropdown-container">
                <div class="input-container-flex">
                  <ng-container *ngIf="serviceOrderTime$|async; let ordertimes">
                    <select class="ya-input-text" (change)="onOrderTimeChange($event.currentTarget.value,ordertimes)">
                      <option value="" disabled selected></option>
                      <ng-container *ngFor="let orderTime of ordertimes; let i = index">
                        <option [value]="i" [selected]="isOrderTimeSelected(orderTime,i)">
                          {{ orderTime.display }}
                        </option>
                      </ng-container>
                    </select>
                  </ng-container>
                  <div class="inline-icon" inlineSVG="hypersoft-pfeil-unten-voll.svg"></div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <div class="ya-webshop-button-container">
        <ng-container *ngIf="setButtonActive() then activeButton else deactiveButton">
        </ng-container>
        <ng-template #activeButton>
          <button mat-flat-button type="submit" (click)="CreateGroupAndNavigate()">
            <span langkey="phGlobal_Continue"></span></button>
        </ng-template>
        <ng-template #deactiveButton>
          <button mat-flat-button disabled><span langkey="phGlobal_Continue"></span></button>
        </ng-template>
      </div>
    </div>
  </div>
</div>